import React, { useState } from "react";
import wretch from "wretch";
import { Link } from "react-router-dom"; //  Uses React Router 7

import "./ForgotPassword.scss";

import Logo from "../../__assets/img/qlogo-color.svg";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [isFormLoading, setIsFormLoading] = useState(false);
  const [confirmType, setConfirmType] = useState(null);

  const submitForgotPassword = async (e) => {
    e.preventDefault();

    await wretch(`${process.env.REACT_APP_UTIL_API_URL}/inquiry`)
      .post({
        email: email,
        message: `Please reset the password for this email address: ${email}. Thanks!`,
      })
      .error(404, () => {
        setIsFormLoading(false);
        setConfirmType("notfound");
      })
      .error(500, (error) => {
        console.log(error);
        setConfirmType("error");
      })
      .json(() => {
        setIsFormLoading(false);
        setConfirmType("success");
      });

    setTimeout(() => {
      setConfirmType(null);
    }, 7000);
  };

  return (
    <div className="fp-wrapper">
      <div className="fp-form-container">
        <div className="form-logo">
          <img alt="IntelliSense Systems" src={Logo} />
        </div>
        <form className="fp-form" onSubmit={submitForgotPassword}>
          <div className="form-row">
            <label htmlFor="fp-email">Email Address</label>
            <br />
            <input
              required
              id="fp-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="form-row">
            <input type="submit" value="Send Email" disabled={isFormLoading} />
          </div>
          <div className="form-row">
            <div></div>
            <div className="confirm-block">
              <div
                className={`confirmation-message success ${
                  confirmType === "success" ? "show" : ""
                }`}
              >
                Your password reset request has been sent to our support team.
              </div>
              <div
                className={`confirmation-message error ${
                  confirmType === "notfound" ? "show" : ""
                }`}
              >
                This email address is not registered.
                <br />
                Please check it or email us directly at quantimet@intellisenseinc.com.
              </div>
              <div
                className={`confirmation-message error ${
                  confirmType === "error" ? "show" : ""
                }`}
              >
                Sorry, there was an error sending the email.
                <br />
                Please try again or email us directly at quantimet@intellisenseinc.com.
              </div>
            </div>
          </div>
        </form>
        <div className="more-login-actions">
          <Link to="/">Back to Login</Link>
          <Link to="/register">Request Account</Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
